var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.cards),function(card){return _c('v-col',{key:card.title,attrs:{"cols":"12","sm":"6","md":"3"}},[_c('card',{attrs:{"title":card.title,"description":card.description,"icon":card.icon}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }